export const formFields = [
  {
    id: 1,
    name: "lastName",
    label: "Фамилия",
    type: "text",
    placeholder: "Введите фамилию",
  },
  {
    id: 2,
    name: "firstName",
    label: "Имя",
    type: "text",
    placeholder: "Введите имя",
  },
  {
    id: 3,
    name: "patronymic",
    label: "Отчество",
    type: "text",
    placeholder: "Введите отчество",
  },
  {
    id: 4,
    name: "birthDate",
    label: "Дата рождения",
    type: "date",
    placeholder: "Введите дату рождения",
  },
  {
    id: 5,
    name: "phoneNumber",
    label: "Номер телефона",
    type: "tel",
    placeholder: "+7 (999) 999 99 99",
  },
  {
    id: 6,
    name: "eduOrganization",
    label: "Образовательная организация",
    type: "text",
    placeholder: "Введите название",
  },
  {
    id: 7,
    name: "participant",
    label: null,
    data: [
      {
        id: 8,
        name: "regionId",
        label: "Регион",
        type: "text",
        placeholder: "Введите название",
      },
      {
        id: 9,
        name: "schoolGrade",
        label: "Класс/группа",
        type: "text",
        placeholder: "Введите класс/группу",
      },
      {
        id: 10,
        name: "city",
        label: "Населенный пункт",
        type: "text",
        placeholder: "Введите название",
      },
    ],
  },
  {
    id: 11,
    name: "mentor",
    label: null,
    data: [
      {
        id: 12,
        name: "jobTitle",
        label: "Должность",
        type: "text",
        placeholder: "Введите должность",
      },
    ]
  },
  {
    id: 13,
    name: "email",
    label: "Электронная почта",
    type: "email",
    placeholder: "Введите адрес электронной почты",
  },
  {
    id: 14,
    name: "password",
    label: "Пароль",
    type: "password",
    placeholder: "Введите пароль",
  },
  {
    id: 15,
    name: "retryPassword",
    label: "Повтор пароля",
    type: "password",
    placeholder: "Введите пароль",
  },
];

export const formFieldsProfile = [
  {
    id: 1,
    name: "lastName",
    label: "Фамилия",
    type: "text",
    placeholder: "Введите фамилию",
  },
  {
    id: 2,
    name: "firstName",
    label: "Имя",
    type: "text",
    placeholder: "Введите имя",
  },
  {
    id: 3,
    name: "patronymic",
    label: "Отчество",
    type: "text",
    placeholder: "Введите отчество",
  },
  {
    id: 4,
    name: "birthDate",
    label: "Дата рождения",
    type: "date",
    placeholder: "Введите дату рождения",
  },
  {
    id: 5,
    name: "phoneNumber",
    label: "Номер телефона",
    type: "tel",
    placeholder: "+7 (999) 999 99 99",
  },
  {
    id: 6,
    name: "eduOrganization",
    label: "Образовательная организация",
    type: "text",
    placeholder: "Введите название",
  },
  {
    id: 7,
    name: "participant",
    label: null,
    data: [
      {
        id: 8,
        name: "regionId",
        label: "Регион",
        type: "text",
        placeholder: "Введите название",
      },
      {
        id: 9,
        name: "schoolGrade",
        label: "Класс/группа",
        type: "text",
        placeholder: "Введите класс/группу",
      },
      {
        id: 10,
        name: "city",
        label: "Населенный пункт",
        type: "text",
        placeholder: "Введите название",
      },
    ],
  },
  {
    id: 11,
    name: "mentor",
    label: null,
    data: [
      {
        id: 12,
        name: "jobTitle",
        label: "Должность",
        type: "text",
        placeholder: "Введите должность",
      },
    ]
  },
  {
    id: 13,
    name: "email",
    label: "Электронная почта",
    type: "email",
    placeholder: "Введите адрес электронной почты",
  }
];

export const loginFields = [
  {
    id: 1,
    name: "email",
    type: "email",
    placeholder: "Введите адрес электронной почты",
  },
  {
    id: 2,
    name: "retryPassword",
    type: "password",
    placeholder: "Введите пароль",
  },
];
